// import React from 'react';
// import { Link } from 'react-router-dom';

// export default function PepsiDetail() {
//   return (
//     <>
//     <div className="min-h-screen bg-gray-100 p-4 md:p-8 mt-12">
//       <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6">

//         {/* Left Side - Main Post */}
//         <div className="lg:w-2/3 w-full bg-white shadow-md rounded-lg overflow-hidden">
//           <img src="/assets/pepsi1.webp" alt="Pepsi Main" className="w-full h-64 object-cover" />
//           <div className="p-4">
//             <h2 className="text-xl font-semibold mb-2">Pepsi Unveils New Summer Campaign: Refresh Your World</h2>
//             <p className="text-gray-600 mb-4">
//               Pepsi’s latest campaign brings a bold twist to summer refreshment. With vibrant visuals and a powerful message, the brand invites everyone to embrace their boldest selves and enjoy the ultimate refreshment experience.
//             </p>
//             <div className="flex justify-between text-sm text-gray-500">
//               <span>Category: Brand Campaign</span>
//               <span>54 Comments | Featured</span>
//             </div>
//           </div>
//         </div>

//         {/* Right Side - Smaller Posts */}
//         <div className="lg:w-1/3 w-full flex flex-col gap-6">

//           {/* Post 1 */}
//           <div className="bg-white shadow-md rounded-lg overflow-hidden">
//             <img src="/assets/pepsi1.webp" alt="Pepsi Post 1" className="w-full h-40 object-cover" />
//             <div className="p-4">
//               <h3 className="text-lg font-semibold mb-2">Pepsi’s Digital Transformation in Advertising</h3>
//               <p className="text-gray-600 mb-2">
//                 From traditional TV spots to immersive AR filters, Pepsi continues to innovate in digital spaces.
//               </p>
//               <div className="flex justify-between text-sm text-gray-500">
//                 <span>Category: Digital Media</span>
//                 <span>87 Comments</span>
//               </div>
//             </div>
//           </div>

//           {/* Post 2 */}
//           <div className="bg-white shadow-md rounded-lg overflow-hidden">
//             <img src="/assets/pepsi1.webp" alt="Pepsi Post 2" className="w-full h-40 object-cover" />
//             <div className="p-4">
//               <h3 className="text-lg font-semibold mb-2">The Pepsi Generation: A Legacy of Boldness</h3>
//               <p className="text-gray-600 mb-2">
//                 Explore how Pepsi’s message of youth, energy, and individuality continues to resonate across decades.
//               </p>
//               <div className="flex justify-between text-sm text-gray-500">
//                 <span>Category: Brand Story</span>
//                 <span>213 Comments</span>
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>

//       {/* Additional Post Below */}
//       <div className="max-w-7xl mx-auto mt-8 bg-white shadow-md rounded-lg overflow-hidden">
//         <img src="/assets/pepsi1.webp" alt="Pepsi Post 3" className="w-full h-64 object-cover" />
//         <div className="p-4">
//           <h2 className="text-xl font-semibold mb-2">Pepsi & Pop Culture: Collaborations That Made History</h2>
//           <p className="text-gray-600 mb-4">
//             From global icons like Beyoncé and Michael Jackson to the Super Bowl halftime show, Pepsi has always been at the heart of culture and entertainment.
//           </p>
//           <div className="flex justify-between text-sm text-gray-500">
//             <span>Category: Culture</span>
//             <span>108 Comments</span>
//           </div>
//         </div>
//       </div>
//     </div>
//      <div className="max-w-7xl mx-auto px-4 py-10">
//                         <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Similar Ads</h1>

//                         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//                           {/* Card 1 */}
//                           <Link to="/canesten" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//                             <img
//                               src="/assets/prism.jpg"
//                               alt="Card 1"
//                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//                             />
//                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//                               <h2 className="text-lg font-semibold">Canesten</h2>
//                             </div>
//                           </Link>

//                           {/* Card 2 */}
//                           <Link to="/carrotate" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//                             <img
//                               src="/assets/car4.webp"
//                               alt="Card 2"
//                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//                             />
//                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//                               <h2 className="text-lg font-semibold">Car 360</h2>
//                             </div>
//                           </Link>

//                           {/* Card 3 */}
//                           <Link to="/luxarycloset" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//                             <img
//                               src="/assets/luxary.webp"
//                               alt="Card 3"
//                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//                             />
//                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//                               <h2 className="text-lg font-semibold">Luxary Closet</h2>
//                             </div>
//                           </Link>

//                           {/* Card 4 */}
//                           <Link to="/ps" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//                             <img
//                               src="/assets/ps.avif"
//                               alt="Card 4"
//                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//                             />
//                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//                               <h2 className="text-lg font-semibold">Pepsi</h2>
//                             </div>
//                           </Link>

//                         </div>
//                       </div>
//     </>
//   );
// }

// // import React from 'react';

// // export default function PepsiDetail() {
// //   return (
// //     <div className="min-h-screen bg-gray-100 p-4 md:p-8 mt-12">
// //       <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6">

// //         {/* Left Side - Main Post */}
// //         <div className="lg:w-2/3 w-full bg-white shadow-md rounded-lg overflow-hidden">
// //           <img src="/assets/pepsi1.webp" alt="Main Post" className="w-full h-64 object-cover" />
// //           <div className="p-4">
// //             <h2 className="text-xl font-semibold mb-2">Eskimi Launches 'Disable Made For Advertising' Feature</h2>
// //             <p className="text-gray-600 mb-4">
// //               The advertising industry's love affair with "cheap reach" was supposed to come to an end as curation became the industry buzzword...
// //             </p>
// //             <div className="flex justify-between text-sm text-gray-500">
// //               <span>Category: Advertising</span>
// //               <span>22 Comments | Left Top</span>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Right Side - Smaller Posts */}
// //         <div className="lg:w-1/3 w-full flex flex-col gap-6">

// //           {/* Post 1 */}
// //           <div className="bg-white shadow-md rounded-lg overflow-hidden">
// //             <img src="/assets/pepsi1.webp" alt="Post 1" className="w-full h-40 object-cover" />
// //             <div className="p-4">
// //               <h3 className="text-lg font-semibold mb-2">Traditional vs. digital: The shifting landscape</h3>
// //               <div className="flex justify-between text-sm text-gray-500">
// //                 <span>Category: Digital</span>
// //                 <span>32 Comments</span>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Post 2 */}
//           <div className="bg-white shadow-md rounded-lg overflow-hidden">
//             <img src="/assets/pepsi1.webp" alt="Post 2" className="w-full h-40 object-cover" />
//             <div className="p-4">
//               <h3 className="text-lg font-semibold mb-2">Why cookieless advertising matters for businesses</h3>
//               <div className="flex justify-between text-sm text-gray-500">
//                 <span>Category: Advertising</span>
//                 <span>332 Comments</span>
//               </div>
//             </div>
//           </div>

// //         </div>
// //       </div>

// //       {/* Additional Post Below */}
// //       <div className="max-w-7xl mx-auto mt-8 bg-white shadow-md rounded-lg overflow-hidden">
// //         <img src="/assets/pepsi1.webp" alt="Additional Post" className="w-full h-64 object-cover" />
// //         <div className="p-4">
// //           <h2 className="text-xl font-semibold mb-2">Media Buying: Optimizing Your Ad Spend in 2024</h2>
// //           <p className="text-gray-600 mb-4">
// //             According to a report from market research firm Fact.mr, as of 2022, the worldwide market for media purchasing services is valued at $69 billion...
// //           </p>
// //           <div className="flex justify-between text-sm text-gray-500">
// //             <span>Category: Ad</span>
// //             <span>22 Comments</span>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }
import React, { useState } from "react";
import {
  ArrowLeft,
  Eye,
  ArrowRight,
  Heart,
  MapPin,
  Calendar,
  Star,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NativeAdContent = ({ isInPreview = false }) => {
  return (
    <div className="w-full h-full relative overflow-hidden bg-white rounded-lg">
      {/* Native Ad Content */}
      <div className="relative h-full">
        {/* Main Content Container */}
        <div className="p-4 h-full flex flex-col">
          {/* Ad Label */}
          <div className="flex justify-between items-center mb-3">
            <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs font-medium">
              SPONSORED
            </span>
            <Heart className="w-4 h-4 text-gray-400 hover:text-red-500 cursor-pointer transition-colors" />
          </div>

          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mb-3">
            <span className="text-white font-bold text-lg">B</span>
          </div>

          {/* Title and Description */}
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight">
              Premium Business Solutions for Modern Companies
            </h3>
            <p className="text-gray-600 text-sm mb-3 leading-relaxed">
              Transform your business with our cutting-edge tools and expert
              guidance. Join thousands of satisfied customers worldwide.
            </p>

            {/* Features List */}
            <div className="mb-4">
              <div className="flex items-center text-sm text-gray-600 mb-1">
                <Star className="w-3 h-3 text-yellow-500 mr-2" />
                <span>Industry-leading performance</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-1">
                <MapPin className="w-3 h-3 text-blue-500 mr-2" />
                <span>Available in 50+ countries</span>
              </div>
              <div className="flex items-center text-sm text-gray-600">
                <Calendar className="w-3 h-3 text-green-500 mr-2" />
                <span>24/7 customer support</span>
              </div>
            </div>

            {/* Pricing */}
            <div className="mb-4">
              <div className="flex items-baseline">
                <span className="text-2xl font-bold text-gray-900">$29</span>
                <span className="text-sm text-gray-500 ml-1">/month</span>
                <span className="bg-red-100 text-red-600 text-xs px-2 py-1 rounded ml-2">
                  50% OFF
                </span>
              </div>
              <p className="text-xs text-gray-500">Usually $58/month</p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mt-auto">
            <button className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-4 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all duration-200 transform hover:scale-105 shadow-md">
              Get Started Today
            </button>
            <p className="text-xs text-gray-500 text-center mt-2">
              Free trial • No credit card required
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

function NativeAdTemplate() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>
      <Helmet>
        <title>Pepsi Campaign | Native Display Ad Showcase by Bidbox</title>
        <meta
          name="description"
          content="See how Pepsi leverages Native Display ads with Bidbox. Explore engaging creatives & strategies that boost visibility and connect with audiences."
        />
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
        <link rel="canonical" href="https://bidbox.ai/native-display/pepsi" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <div className="min-h-screen bg-gray-50 mt-10">
        <div className="container mx-auto px-4 py-8 lg:py-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
            {/* Left column - Content */}
            <div className="flex-1 lg:max-w-lg">
              {/* Header */}
              <header className="animate-slide-up">
                {/* Title and tag */}
                <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                      Native Ad Template
                    </h1>
                    <span className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                      Native Display
                    </span>
                  </div>
                </div>
              </header>

              {/* Content Section */}
              <div
                className="animate-slide-up"
                style={{ animationDelay: "0.2s" }}
              >
                {/* Make it yours section */}
                <div className="mb-8">
                  <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                    MAKE IT YOURS!
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                    You can start with this premade native ad template – just
                    change the content, branding, and offer to your own and you
                    can have your creative ready in no time.
                  </p>

                  {/* CTA Button */}
                  <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                    <span>Start with this Template</span>
                    <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                  </button>
                </div>
              </div>
            </div>

            {/* Right column - Template Preview */}
            <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
              {/* Preview toggle */}
              <div
                className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4"
                style={{ animationDelay: "0.3s" }}
              >
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-3">
                      <span
                        className={`text-sm font-medium transition-colors ${
                          isMobile ? "text-blue-600" : "text-gray-600"
                        }`}
                      >
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div
                          className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${
                            isMobile ? "left-1" : "left-7"
                          }`}
                        ></div>
                      </button>
                      <span
                        className={`text-sm font-medium transition-colors ${
                          !isMobile ? "text-blue-600" : "text-gray-600"
                        }`}
                      >
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="relative animate-fade-in"
                style={{ animationDelay: "0.4s" }}
              >
                {/* Mobile Mockup */}
                {isMobile && (
                  <div className="mx-auto max-w-xs">
                    {/* iPhone mockup */}
                    <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
                      {/* Status bar area */}
                      <div className="bg-white rounded-[2rem] overflow-hidden">
                        {/* Status bar */}
                        <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                          <span>9:41</span>
                          <div className="flex items-center space-x-1">
                            <div className="flex space-x-1">
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                            </div>
                            <div className="w-6 h-3 border border-black rounded-sm relative">
                              <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                            </div>
                          </div>
                        </div>

                        {/* Browser bar */}
                        <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                          <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                            publisher.com
                          </div>
                        </div>

                        {/* Content area */}
                        <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                          <div className="space-y-3 mb-4">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                          </div>

                          {/* Native Ad - Pepsi Style Layout */}
                          <div className="mb-6 bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                            {/* Main Image */}
                            {/* <div className="h-32 bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                            <div className="text-white text-center">
                              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-2">
                                <span className="text-2xl font-bold">B</span>
                              </div>
                              <p className="text-sm font-medium">Premium Solutions</p>
                            </div>
                          </div> */}

                            {/* Content */}
                            {/* <div className="p-3">
                            <div className="flex justify-between items-start mb-2">
                              <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs font-medium">
                                SPONSORED
                              </span>
                              <Heart className="w-4 h-4 text-gray-400" />
                            </div>
                            <h3 className="font-semibold text-sm mb-1">Premium Business Solutions</h3>
                            <p className="text-xs text-gray-600 mb-2">
                              Transform your business with cutting-edge tools and expert guidance.
                            </p>
                            <div className="flex justify-between items-center text-xs text-gray-500 mb-2">
                              <span>Category: Business Tools</span>
                              <span>⭐ 4.9 Rating</span>
                            </div>
                            <button className="w-full bg-blue-500 text-white py-2 px-3 rounded text-xs font-medium">
                              Get Started - $29/mo
                            </button>
                          </div> */}
                            <div className="bg-white shadow-md rounded-lg overflow-hidden">
                              <img
                                src="/assets/pepsi1.webp"
                                alt="Post 2"
                                className="w-full h-40 object-cover"
                              />
                              <div className="p-4">
                                <h3 className="text-md mb-2  font-medium font-serif">
                                  Pepsi's Digital Transformation in Advertising
                                </h3>
                                {/* <div className="flex justify-between text-sm text-gray-500 font-serif">
                <span>Category: Advertising</span>
                <span>332 Comments</span>
              </div> */}
                              </div>
                            </div>
                          </div>

                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Desktop Mockup */}
                {!isMobile && (
                  <div className="w-full max-w-2xl mx-auto">
                    {/* Desktop Screen Frame */}
                    <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                      {/* Screen */}
                      <div
                        className="bg-white rounded-lg overflow-hidden shadow-inner"
                        style={{ aspectRatio: "16/10" }}
                      >
                        {/* macOS-style window header */}
                        <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
                          <div className="flex space-x-2">
                            <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                          </div>
                          <div className="flex-1 mx-6">
                            <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                              🔒 publisher.com
                            </div>
                          </div>
                          <div className="flex space-x-1">
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          </div>
                        </div>

                        {/* Browser content area */}
                        <div className="p-6 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                          {/* Page header */}
                          <div className="mb-6">
                            <div className="h-4 bg-gray-200 rounded w-10/12 mb-2"></div>
                            <div className="h-3 bg-gray-200 rounded w-10/12"></div>
                          </div>
                          {/* Native Ad - Pepsi Style Layout */}
                          <div className="flex gap-6 mb-8">
                            {/* Main Post - 2/3 width */}
                            <div className="w-2/3  overflow-hidden">
                              {/* <div className="h-40 bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                              <div className="text-white text-center">
                                <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                                  <span className="text-3xl font-bold">B</span>
                                </div>
                                <p className="text-lg font-medium">Premium Business Solutions</p>
                              </div>
                            </div> */}
                              {/* <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <img src="/assets/pepsi1.webp" alt="Post 2" className="w-full h-40 object-cover" />
            <div className="p-4">
              <h3 className="text-lg font-semibold mb-2">Why cookieless advertising matters for businesses</h3>
              <div className="flex justify-between text-sm text-gray-500">
                <span>Category: Advertising</span>
                <span>332 Comments</span>
              </div>
            </div>
          </div> */}
                              <div className="grid grid-cols-2 gap-6 mb-6">
                                <div className="space-y-3">
                                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                                  <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                                </div>
                                <div className="space-y-3">
                                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                                  <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                                </div>
                              </div>
                              <div className="grid grid-cols-2 gap-6 mb-6">
                                <div className="space-y-3">
                                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                                  <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                                </div>
                                <div className="space-y-3">
                                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                                  <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                                </div>
                              </div>
                              <div className="grid grid-cols-2 gap-6 mb-6">
                                <div className="space-y-3">
                                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                                  <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                                </div>
                                <div className="space-y-3">
                                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                                  <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                                </div>
                              </div>
                            </div>

                            {/* Side Posts - 1/3 width */}
                            <div className="bg-white shadow-md rounded-lg overflow-hidden">
                              <img
                                src="/assets/pepsi1.webp"
                                alt="Post 2"
                                className="w-full h-40 object-cover"
                              />
                              <div className="p-4">
                                <h3 className="text-md font-medium mb-2 font-serif">
                                  Pepsi's Digital Transformation in Advertising
                                </h3>
                                {/* <div className="flex justify-between text-sm text-gray-500 font-serif">
                <span>Category: Advertising</span>
                <span>332 Comments</span>
              </div> */}
                              </div>
                            </div>
                          </div>
                          {/* Additional content placeholders */}
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Monitor stand */}
                    <div className="flex justify-center">
                      <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                    </div>
                    <div className="flex justify-center">
                      <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes slide-up {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fade-in {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          .animate-slide-up {
            animation: slide-up 0.6s ease-out forwards;
          }

          .animate-fade-in {
            animation: fade-in 0.6s ease-out forwards;
          }

          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}</style>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">
          Discover More Ads
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* Card 1 */}
          <Link
            to="/scratch-to-win/hm"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/sc.avif"
              alt="Card 1"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Scratch TO Win</h2>
            </div>
          </Link>

          {/* Card 2 */}
          <Link
            to="/swipe-to-reveal/pizza"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/sw.jpg"
              alt="Card 2"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Swipe to Reveal</h2>
            </div>
          </Link>

          {/* Card 3 */}
          <Link
            to="/tap-to-reveal/thumsup"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/tmmm.png"
              alt="Card 3"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Tap to Reveal</h2>
            </div>
          </Link>

          {/* Card 4 */}
          <Link
            to="/interactive-selector/travel-ramadan"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/du.jpg"
              alt="Card 4"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Dubai Travel</h2>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default NativeAdTemplate;
